/**
 * ModalTest Component
 * 
 * A simple component to test modal functionality separately from the complex AlertManager
 * This will help us identify if the issue is with the Modal component itself or its integration
 */
import React, { useState } from 'react';
import Modal from './Modal/Modal';

function ModalTest() {
  const [showModal, setShowModal] = useState(false);
  
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Modal Test</h1>
      
      <button 
        onClick={() => setShowModal(true)}
        style={{
          padding: '10px 15px',
          backgroundColor: '#4a90e2',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        Open Test Modal
      </button>
      
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="Test Modal"
        size="medium"
      >
        <div style={{ padding: '20px' }}>
          <h2>Modal Content Test</h2>
          <p>This is a test of the modal component to verify it displays correctly.</p>
          <p>If you can see this content, the modal is working properly.</p>
          
          <div style={{ marginTop: '20px' }}>
            <button
              onClick={() => setShowModal(false)}
              style={{
                padding: '10px 15px',
                backgroundColor: '#4a90e2',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              Close Modal
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default ModalTest;
